export const auth = {
  email: 'Email',
  emailPlaceholder: 'Enter your email',
  password: 'Password',
  passwordPlaceholder: 'Enter your password',
  confirmPassword: 'Confirm Password',
  confirmPasswordPlaceholder: 'Confirm your password',
  firstName: 'First Name',
  firstNamePlaceholder: 'Enter your first name',
  lastName: 'Last Name',
  lastNamePlaceholder: 'Enter your last name',
  signIn: 'Sign In',
  signInDescription: 'Sign in to your account',
  signUp: 'Sign Up',
  signUpDescription: 'Create your Referent account',
  forgotPassword: 'Forgot password?',
  forgotPasswordTooltip: 'Contact our team to reset your password',
  rememberMe: 'Remember me',
  noAccount: "Don't have an account?",
  haveAccount: 'Already have an account?',
  loginSuccess: 'Welcome back!',
  registerSuccess: 'Account created successfully! Please sign in.',
  passwordMismatch: 'Passwords do not match',
  maintenance: {
    title: 'We are working on something amazing',
    greeting: 'Hello {{name}}!',
    subtitle:
      'Our team is working hard to provide you with the best tools to make your teams perform better. We will see you soon!',
  },
} as const
